import { Stack } from '@mui/material';
import DeleteButton from 'domains/core/components/DeleteButton';
import { VoiceContentAction, VoiceContentInteraction } from 'pages/ContentVoiceBuilderPage/types';
import { removeInteraction } from 'pages/ContentVoiceBuilderPage/voiceCallActions';
import KeypadOptionSelect from './KeypadOptionSelect';
import ActionSelect from './ActionSelect';
import ActionValueInput from './ActionValueInput';

type Props = {
    dispatchVoiceContentAction: React.Dispatch<any>;
    index: number;
    interaction: VoiceContentInteraction;
    selectedKeypadOptions: string[];
};

const Interaction = ({ dispatchVoiceContentAction, index, interaction, selectedKeypadOptions }: Props) => {
    const isOptOut = interaction.type === VoiceContentAction.DO_NOT_DISTURB;

    return (
        <Stack
            columnGap={2}
            direction="row"
            sx={{
                alignSelf: 'flex-start',
                border: '1px solid',
                borderColor: 'other.divider',
                borderRadius: '6px',
                flexWrap: 'wrap',
                padding: `24px ${isOptOut ? '22px' : '12px'} 12px 22px`,
            }}
            rowGap={2}
        >
            <KeypadOptionSelect
                dispatchVoiceContentAction={dispatchVoiceContentAction}
                index={index}
                interaction={interaction}
                selectedKeypadOptions={selectedKeypadOptions}
            />
            <ActionSelect
                dispatchVoiceContentAction={dispatchVoiceContentAction}
                index={index}
                interaction={interaction}
            />
            <ActionValueInput
                dispatchVoiceContentAction={dispatchVoiceContentAction}
                index={index}
                interaction={interaction}
            />
            {!isOptOut && (
                <DeleteButton
                    onClick={() => dispatchVoiceContentAction(removeInteraction(index))}
                    sx={{ alignSelf: 'flex-start' }}
                    tooltipTitle="Remove interaction"
                />
            )}
        </Stack>
    );
};

export default Interaction;
